import kebabCase from 'lodash.kebabcase';
import { applyClasses } from '../shared/js';

// Transforms camelCased props into kebab-cased bootstrap classes
// Then returns the scoped classnames from the css module to the component
export const applyBootstrapClasses = (props, styles) => {
  const bootstrapClasses = {};
  Object.entries(props).forEach(
    ([propName, value]) =>
      (bootstrapClasses[translateBootstrapClass(propName)] = value)
  );
  return applyClasses(bootstrapClasses, styles);
};

export const translateBootstrapClass = (bootstrapClass) => {
  return kebabCase(bootstrapClass);
};
